var map = {
	"./mobile/team/InviteJoinSuccess": [
		"4b85",
		"pc-base0"
	],
	"./pc/team/InviteJoinSuccess": [
		"9653",
		"pc-base1"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "bcf0";
module.exports = webpackAsyncContext;